import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "depanne93_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const formatErr = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return e?.message || "Erreur inattendue";
};

export const formatPrice = (n) => {
  if (n == null || isNaN(n)) return "—";
  return new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n);
};

export const STATUS_LABELS = {
  nouvelle: "Nouvelle demande",
  a_rappeler: "À rappeler",
  devis_envoye: "Devis envoyé",
  devis_accepte: "Devis accepté",
  chauffeur_assigne: "Chauffeur assigné",
  en_route: "Dépanneur en route",
  sur_place: "Sur place",
  vehicule_charge: "Véhicule chargé",
  vehicule_livre: "Véhicule livré",
  facture: "Facturé",
  paye: "Payé",
  termine: "Terminé",
  annule: "Annulé",
  perdu: "Perdu",
};

export const SERVICE_TYPES = [
  { value: "depannage-panne", label: "Dépannage panne" },
  { value: "remorquage-accident", label: "Remorquage accident" },
  { value: "transport-vehicule", label: "Transport de véhicule" },
  { value: "sortie-fourriere", label: "Sortie fourrière" },
  { value: "batterie", label: "Batterie" },
  { value: "crevaison", label: "Crevaison" },
  { value: "vehicule-non-roulant", label: "Véhicule non roulant" },
];

export const VEHICLE_TYPES = [
  { value: "citadine", label: "Citadine" },
  { value: "berline", label: "Berline" },
  { value: "suv", label: "SUV" },
  { value: "utilitaire", label: "Utilitaire léger" },
  { value: "hybride", label: "Véhicule hybride" },
  { value: "electrique", label: "Véhicule électrique" },
];
